module.exports = __webpack_public_path__ + "00_mole.1f63ce66.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer2/00_mole.png
// module id = 6Kbq
// module chunks = 0